export default __webpack_public_path__ + "static/media/admin.4da8bf91.png";